//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { convertReportFromServer } from './Report.js'
import { createFieldConfig } from '../../components/QSelectUtils.js'

import ReportMinimal from './ReportMinimal.vue'
import ReportArhiveObject from '../Report/ReportArhive/ReportArhiveObject.vue'

export default {
  components: {
    ReportMinimal,
    ReportArhiveObject
  },
  props: {
    serviceObjectId: {
      type: Number,
      required: true
    },
    serviceObjectType: {
      type: String,
      default: null
    },
    collapseFirstReportPhoto: {
      type: Boolean,
      default: false
    },
    serviceObjectNumber: {
      type: String,
      default: null
    }
  },
  data: function () {
    const searchFieldsOptions = [
      { id: 'applicantDescr', name: 'Описание заявки от заявителя' },
      { id: 'commonWorkComment', name: 'Общий комментарий к работе' }
    ]
    return {
      searchText: null,
      showSearch: false,
      searchFields: searchFieldsOptions,
      searchFieldsConfig: createFieldConfig({ allRecordsFn: () => Promise.resolve(searchFieldsOptions) }),

      blackYellowStat: null,

      itemsToShow: [],
      itemsTotal: null,
      itemsLeft: 0,
      itemsNextPageSize: 0,
      loading: false,
      requestArhive: {},
      expandedArhive: false
    }
  },
  computed: {
    displayArchiveSection: function () {
      const user = this.$store.getters.getUser
      if (user.hasSystemRoleStrict('publicationRead') || user.strictRestrictedAccess) { // TODO по доступу к данным объекта обслуживания
        return false
      }
      return true
    },
    searchFieldKeys: function () {
      return this.searchFields && this.searchFields.map(field => field.id)
    }
  },
  watch: {
    serviceObjectId: {
      handler: function (id) {
        if (!this.loading) {
          this.itemsToShow = []
          this.itemsTotal = null
          if (id) {
            this.loadNextPage()
          } else {
            this.itemsLeft = 0
            this.itemsNextPageSize = 0
          }
        }
      },
      immediate: true
    },
    expandedArhive: function (value) {
      if (value) {
        const objectType = this.getArhiveObjectType(this.serviceObjectType)
        this.$set(this.requestArhive, 'type', objectType)
        this.$set(this.requestArhive, 'objectNumber', this.serviceObjectNumber)
        const typeName = this.getArhiveObjectType(this.serviceObjectType, true)
        this.$set(this.requestArhive, 'typeName', typeName)
      } else {
        this.requestArhive = {}
      }
    }
  },
  methods: {
    onSearch: function () {
      this.itemsToShow = []
      this.loadNextPage()
    },
    showSearchSettings: function () {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.searchFields = data.searchFields
            if (this.searchText) {
              this.onSearch()
            }
          }
        },
        header: 'Параметры поиска',
        propsConfig: {
          searchFields: {
            label: 'Данные отчёта для поиска введённого текста',
            type: 'objects',
            searchConfig: this.searchFieldsConfig,
            value: this.searchFields,
            required: true
          }
        },
        buttons: [
          { key: 'yes', name: 'Подтвердить' },
          { key: 'cancel', name: 'Отмена' }
        ]
      })
    },
    loadNextPage: async function () {
      if (!this.$d_hasOperation('serviceObjectReportsView')) {
        return
      }

      this.loading = true
      try {
        const startIndex = this.itemsToShow.length
        const pageSize = 10
        const itemsLoaded = await this.loadItems(startIndex, pageSize)
        this.itemsToShow.push(...itemsLoaded)
        this.itemsLeft = this.itemsTotal - this.itemsToShow.length
        this.itemsNextPageSize = Math.min(pageSize, this.itemsLeft)
      } catch (ignored) {
      } finally {
        this.$nextTick(() => {
          this.loading = false
        })
      }
    },
    loadItems: function (startIndex, pageSize) {
      const urlParams = new URLSearchParams()
      urlParams.append('start', startIndex)
      urlParams.append('limit', pageSize)
      urlParams.append('external', false)
      if (this.serviceObjectType) {
        urlParams.append('type', this.serviceObjectType)
      }
      if (this.searchText) {
        urlParams.append('pattern', this.searchText)
        urlParams.append('patternParams', this.searchFieldKeys.toString())
      }

      return axiosGet({
        url: '/service/delta/serviceobject/reportsHistory/' + this.serviceObjectId + '?' + urlParams.toString(),
        onSuccess: (response) => {
          const black = response.data.result.stat.trafficLight_4
          const yellow = response.data.result.stat.trafficLight_2
          this.blackYellowStat = (black || 0) + (yellow || 0)

          const user = this.$store.getters.getUser

          this.itemsTotal = response.data.result.total
          const reportsRaw = response.data.result.reports
          return reportsRaw.map(reportRaw => {
            if (reportRaw.external) {
              return reportRaw
            } else {
              return convertReportFromServer(reportRaw, user)
            }
          })
        },
        onFailure: 'Ошибка получения истории отчётов по объекту обслуживания'
      })
    },
    getArhiveObjectType: function (type, text = false) {
      let name = ''
      switch (type) {
        case 'trafficLight':
          name = text ? 'СО' : 'tl'
          break
        case 'trafficLightT7':
          name = text ? 'Т7' : 't7'
          break
        case 'cameraTV':
          name = text ? 'КТО' : 'kto'
          break
        case 'transportDetector':
          name = text ? 'ДТ' : 'detector'
          break
        case 'TOI':
          name = text ? 'ТОИ' : 'table'
          break
        case 'cameraFVF':
          name = text ? 'ФВФ' : 'fvf'
          break
        default :
          break
      }
      return name
    }
  }
}

